<template>
  <div
    v-if="isBusy"
    class="row">
    <!-- Busy -->
    <div
      class="col text-center">
      <coozzy-spinner />
    </div>
  </div>
  <section
    v-else
    data-cy="application-form-individual-section">
    <application-form-individual-basic
      ref="basic"
      :individual-id="individualId"
      :sending="sending"
      :changed-address="changedAddress"
      :object="object"
      :email-main-tenant="emailMainTenant"
      :is-guarantor="isGuarantor"
      @address-changed="addressChanged" />
    <hr v-if="object && object.category !== 'PARKING_SPACE' && object.category !== 'SECONDARY_ROOM'">
    <application-form-employment
      v-if="object && object.category !== 'PARKING_SPACE' && object.category !== 'SECONDARY_ROOM'"
      ref="employment"
      :individual-id="individualId"
      :sending="sending"
      :object="object" />
    <hr v-if="object && object.category !== 'PARKING_SPACE' && object.category !== 'SECONDARY_ROOM' && !individual.tenancy.sameAsMainIndividual">
    <application-form-tenancy
      v-if="object && object.category !== 'PARKING_SPACE' && object.category !== 'SECONDARY_ROOM' && !individual.tenancy.sameAsMainIndividual"
      ref="tenancy"
      :individual-id="individualId"
      :sending="sending"
      :object="object" />
  </section>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import ApplicationFormIndividualBasic from '@/marketingBasic/components/applicationForm/ApplicationFormIndividualBasic.vue'
import ApplicationFormEmployment from '@/marketingBasic/components/applicationForm/ApplicationFormEmployment.vue'
import ApplicationFormTenancy from '@/marketingBasic/components/applicationForm/ApplicationFormTenancy.vue'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import { mapGetters } from 'vuex'
import { ApplicationFormIndividual, ApplicationFormObjectMiscContext } from '@/types/models'

type SubformInvalidRef = { isInvalid: () => boolean }
type BasicDateSyncRef = { syncDateFieldsFromInputs?: () => void }

export default Vue.extend({
  name: 'ApplicationFormIndividual',
  components: {
    ApplicationFormTenancy,
    ApplicationFormEmployment,
    ApplicationFormIndividualBasic,
    CoozzySpinner
  },
  props: {
    individualId: {
      type: String,
      required: true
    },
    sending: {
      type: Boolean,
      default: false
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    changedAddress: {
      type: String,
      default: ''
    },
    object: {
      type: Object as PropType<ApplicationFormObjectMiscContext | null>,
      default: null
    },
    emailMainTenant: {
      type: String,
      default: ''
    },
    isGuarantor: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('applicationForm', ['getIndividualByInternalId']),
    individual(): ApplicationFormIndividual {
      return this.getIndividualByInternalId(this.individualId) as ApplicationFormIndividual
    }
  },
  methods: {
    addressChanged(val: string) {
      this.$emit('address-changed', val)
    },
    syncDateFieldsFromInputs() {
      const basic = this.$refs.basic as BasicDateSyncRef | undefined
      basic?.syncDateFieldsFromInputs?.()
    },
    isInvalid() {
      let allSubformsValid = true
      const basic = this.$refs.basic as SubformInvalidRef | undefined
      const employment = this.$refs.employment as SubformInvalidRef | undefined
      const tenancy = this.$refs.tenancy as SubformInvalidRef | undefined
      if (basic?.isInvalid()) {
        allSubformsValid = false
      }
      if (employment?.isInvalid()) {
        allSubformsValid = false
      }
      if (tenancy?.isInvalid()) {
        allSubformsValid = false
      }
      return !allSubformsValid
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
